import { fields } from '@keystatic/core';
import { mark } from '@keystatic/core/content-components';
import { ReactNode } from 'react';

export const coloredTextMark = mark({
  label: 'Colored Text',
  icon: (
    <svg
      key={'coloredTextMark'}
      className="size-6 text-gray-800 dark:text-white"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        stroke-width="2"
        d="m6.08169 15.9817 1.57292-4m-1.57292 4h-1.1m1.1 0h1.65m-.07708-4 2.72499-6.92967c.0368-.09379.1673-.09379.2042 0l2.725 6.92967m-5.65419 0h-.00607m.00607 0h5.65419m0 0 .6169 1.569m5.1104 4.453c0 1.1025-.8543 1.9963-1.908 1.9963s-1.908-.8938-1.908-1.9963c0-1.1026 1.908-4.1275 1.908-4.1275s1.908 3.0249 1.908 4.1275Z"
      />
    </svg>
  ),
  schema: {
    variant: fields.select({
      label: 'Variant',
      defaultValue: '#ff0055',
      options: [
        { label: 'RedPink', value: '#ff0055' },
        { label: 'Purple', value: '#6600C6' },
        { label: 'Gray', value: '#4F5059' },
        { label: 'White', value: '#FFFFFF' },
      ],
    }),
  },
  tag: 'span',
  style: ({ value }) => ({
    color: value.variant,
  }),
});

interface IColoredTextProps {
  variant: string;
  children: ReactNode;
}

export const ColoredText = ({ variant, children }: IColoredTextProps) => {
  return <span style={{ color: variant }}>{children}</span>;
};
